import { useState, useMemo } from 'react';

import { useDeepCompareLayoutEffect } from '~/hooks/useDeepCompareEffect';
import { useUserAuth } from '~/components/Auth';

import { getAbility, createCanBoundTo } from '../helpers';

import { TPermissions } from '../types';

const useCasl = (contextPermissions: TPermissions) => {
  const { permissions } = useUserAuth();
  const [state, updateState] = useState(getAbility(permissions, contextPermissions));

  useDeepCompareLayoutEffect(() => {
    updateState(getAbility(permissions, contextPermissions));
  }, [contextPermissions, permissions]);

  const Can = useMemo(() => createCanBoundTo(state.ability, state.globalAbility), [
    state.ability,
    state.globalAbility,
  ]);

  const casl = useMemo(
    () => ({ ability: state.ability, globalAbility: state.globalAbility, Can }),
    [state.ability, state.globalAbility, Can]
  );

  return casl;
};

export default useCasl;
